import type { ReactNode } from "react";
import {
  ErrorBoundary as RebErrorBoundary,
  type FallbackProps,
} from "react-error-boundary";
import { useLocale } from "../hooks/useLocale";

function Fallback({ error, resetErrorBoundary }: FallbackProps) {
  const { t } = useLocale();
  return (
    <div role="alert" className="error-boundary">
      <h1>{t("errorBoundary.title")}</h1>
      <p>{t("errorBoundary.message")}</p>
      <pre className="error-boundary__detail">{error.message}</pre>
      <button
        type="button"
        onClick={() => {
          resetErrorBoundary();
          if (typeof window !== "undefined") window.location.reload();
        }}
      >
        {t("errorBoundary.reload")}
      </button>
    </div>
  );
}

export function ErrorBoundary({ children }: { children: ReactNode }) {
  return (
    <RebErrorBoundary
      FallbackComponent={Fallback}
      onError={(err) => {
        // Surface to the console; production wiring (Sentry/etc.) can hook here.
        console.error("[ErrorBoundary]", err);
      }}
    >
      {children}
    </RebErrorBoundary>
  );
}
